// controllers/icon_controller.js
import { Controller } from "@hotwired/stimulus";
import lucide from "lucide/dist/umd/lucide"

export default class extends Controller {
  connect() {
    this.createIcons();
    this.observeMutations();
  }

  observeMutations() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && node.matches('i[data-lucide]')) {
              this.createIcons();
            } else if (node.nodeType === 1) {
              node.querySelectorAll('i[data-lucide]').forEach(() => {
                this.createIcons();
              });
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  createIcons() {
    lucide.createIcons()
  }
}
